import classnames from "classnames";
import { Trans } from "react-i18next";

const ContactUs = ({ className = "" }) => (
  <Trans
    i18nKey="neetoMolecules.browserSupport.contactUs.main"
    components={{
      button: (
        <button
          className={classnames(
            "neeto-molecules-browser-support__link-button",
            className
          )}
          onClick={() => {
            window.NeetoChat?.contextualHelp?.maximizeWidget();
            window.NeetoChat?.contextualHelp?.openWidget();
          }}
        />
      ),
    }}
  />
);

export default ContactUs;
